import { render, staticRenderFns } from "./FileRenameModal.vue?vue&type=template&id=b6717a6e&scoped=true&"
import script from "./FileRenameModal.vue?vue&type=script&lang=ts&"
export * from "./FileRenameModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6717a6e",
  null
  
)

export default component.exports